import { Link } from "react-router-dom";
import commBanner from "../img/community_grafitto_450.jpg"
import mar24Newsletter from "../img/newsletters/png/0324-nl.png"
import decNewsletter from "../img/newsletters/png/121123 nl.png"
import dec22Newsletter from "../img/newsletters/png/1222 nl.png"
import apr23Newsletter from "../img/newsletters/png/0423 nl.png"
import nov22Newsletter from "../img/newsletters/png/1122 nl.png"
import oct22Newsletter from "../img/newsletters/png/1022 nl.png"
import levelUpTrish from "../img/Level-up Trish.png"
import levelUpAngie from "../img/Level-up Angie.png"

export default function Community() {
  return (
    <>
      <div>
        <div className="hero-comm">
          <div id="hero">
            <img className="hero-img" src={commBanner} alt="Community Graffito - by TA2 2024" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="nl-container">
          <h1 className="main-title">Newsletter</h1>
          <p className="min-content">
            Welcome to our newsletter content, where we bring together the best of what's happening
            in our community, from Florida and the rest of the country.
          </p>

          <div>
            <p>
              Click on the images below for the PDF which includes{' '}
              <span className="color-blue">features</span>,{' '}
              <span className="color-blue">articles</span>, and you can{' '}
              <span className="color-blue">SHARE</span> the pdf with your friends and colleagues.
            </p>
          </div>

          <div className="nl-grid">

            {/* mar24 */}
            <div className="nl-card stacked featured">
              <Link to="/src/newsletters/0324-Newsletter.pdf" target="#">
                <img src={mar24Newsletter} alt="March 2024 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="/src/newsletters/0324-Newsletter.pdf" target="#" className="mono card__title">
                    <span className="veep">Mar-24</span>
                  </Link>
                </h3>
                <p className="fs-400 card__description">
                  Interview with a Senator, peer befriending.
                </p>
              </div>
            </div>

            {/* dec23 */}
            <div className="nl-card stacked">
              <Link to="/src/newsletters/121123-Newsletter.pdf" target="#">
                <img src={decNewsletter} alt="December 2023 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="/src/newsletters/121123-Newsletter.pdf" target="#" className="mono card__title">
                    <span className="veep">Dec-23</span>
                  </Link>
                </h3>
                <p className="fs-400 card__description">
                  Bruce revealed! Spotlight on Brooks Rehab Aphasia Center, Jacksonville FL.
                </p>
              </div>
            </div>

            {/* apr23 */}
            <div className="nl-card stacked">
              <Link to="/src/newsletters/0423-newsltr.pdf" target="#">
                <img src={apr23Newsletter} alt="April 2023 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="/src/newsletters/0423-newsltr.pdf" className="mono card__title">Apr-23</Link>
                </h3>
                <p className="fs-400 card__description">
                  Our presentation at Aphasia Access Leadership Summit. Shout out to Lansing friends, plus more.
                </p>
              </div>
            </div>

            {/* dec22 */}
            <div className="nl-card stacked">
              <Link to="/src/newsletters/1222-Newsletter.pdf" target="#">
                <img src={dec22Newsletter} alt="December 2022 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="/src/newsletters/1222-Newsletter.pdf" className="mono card__title">Dec-22</Link>
                </h3>
                <p className="fs-400 card__description">
                  The secret of the success of our community. Shout out to our friends in Philly and more.
                </p>
              </div>
            </div>

            {/* nov22 */}
            <div className="nl-card stacked">
              <Link to="/src/newsletters/1122-Newsletter.pdf" target="#">
                <img src={nov22Newsletter} alt="November 2022 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="" className="mono card__title">
                    <span className="veep">Nov-22</span>
                  </Link>
                </h3>
                <p className="fs-400 card__description">
                  Seminar highlights at ASHA, Voice of hope and useful tools.
                </p>
              </div>
            </div>

            {/* oct22 */}
            <div className="nl-card stacked">
              <Link to="/src/newsletters/1022-newsletter.pdf" target="#">
                <img src={oct22Newsletter} alt="October 2022 Newsletter" className="card__img-nl outline" />
              </Link>
              <div className="card__content">
                <h3>
                  <Link to="" className="mono card__title">Oct-22</Link>
                </h3>
                <p className="fs-400 card__description">
                  Welcome! Friends in California, plus music helps.
                </p>
              </div>
            </div>

          </div>{/* nl-grid */}

          {/* YouTube — after newsletter grid */}
          <div className="youtube">
            <h3>
              Watch some of our community stories{' '}
              <a href="https://youtu.be/NUDQ3rdk1Wc?si=5Jl9bD2ytGrCDlXz" target="_blank" rel="noopener noreferrer">
                HERE
              </a>
            </h3>
            <iframe
              width="100%"
              height="360"
              style={{ maxWidth: '640px', aspectRatio: '16/9', height: 'auto' }}
              src="https://www.youtube.com/embed/NUDQ3rdk1Wc?si=etOo0LmnKU9K5KsV"
              title="NAS Aphasia Story - Michael Obel-Omia"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          {/* Conversations / UD ARO Lab */}
          <div className="extra">
            <h2 className="community color-blue">Conversations</h2>
            <p className="smaller">Click on the images below to go to UD ARO Lab YouTube channel.</p>
            <div className="extra-container">
              <div className="extra-grid">
                <a href="https://www.youtube.com/watch?v=EAF077vwPO0" target="_blank" rel="noopener noreferrer">
                  <img src={levelUpTrish} alt="podcast interview - Trish" />
                </a>
                <a href="https://www.youtube.com/watch?v=eToMijHBRPY" target="_blank" rel="noopener noreferrer">
                  <img src={levelUpAngie} alt="podcast interview - Angie" />
                </a>
              </div>
            </div>
            <p>
              The Aphasia &amp; Rehabilitation Outcomes (ARO) Lab at the University of Delaware
              researched post-stroke aphasia, a language impairment experienced by about 30% of
              stroke survivors. Aphasia impacts speech, understanding, reading, and writing, but not
              intelligence. It can be mild, moderate, or severe. Aphasia from stroke or other brain
              injury can improve with time, treatment, and determination. For more information,
              please visit us at UDAROLab.com.
              <br /><br />
              Check out the aphasia stories featuring PWA at the UD ARO Lab.{' '}
              <br />Please pass it along to your friends and family, or other people with aphasia.
            </p>
            <p>
              For more insightful interviews{' '}
              <a href="https://www.youtube.com/@UDAROLab" target="_blank" rel="noopener noreferrer">
                HERE https://www.youtube.com/@UDAROLab
              </a>:
            </p>
          </div>

        </div>{/* nl-container */}
      </div>{/* container */}
    </>
  );
}